import React, { Fragment, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { mergeStyleSets } from 'office-ui-fabric-react';
import { Stack } from 'office-ui-fabric-react';
import { Callout, DirectionalHint, IconButton } from 'office-ui-fabric-react';

export const HintVerticalPosition = {
    top: "start",
    center: "center",
    bottom: "end",
};

export const HintWrapper = (props) => {

    const [isCalloutVisible, setIsCalloutVisible] = useState(false);

    const classNames = mergeStyleSets({
        iconButton: {
            backgroundColor: props.color,
            borderRadius: props.size / 2,
            height: props.size,
            marginBottom: props.verticalAlign == HintVerticalPosition.bottom ? props.verticalOffset : "unset",
            marginLeft: 7.5,
            marginTop: props.verticalAlign == HintVerticalPosition.top ? props.verticalOffset : "unset",
            width: props.size,
        },
        inner: {
            height: '100%',
            padding: 7.5
        },
    });

    const bubbleStyles = {
        root: {
            borderRadius: props.size / 2,
            display: "flex",
            height: props.size,
            justifyContent: "center",
            width: props.size,
        }
    }

    const iconStyles = {
        root: {
            color: "white",
            fontSize: props.size / 1.75,
        }
    }

    const _target = useRef();

    return <Stack horizontal verticalAlign={props.verticalAlign}>
        <Stack.Item grow>
            {props.children}
        </Stack.Item>
        <Stack.Item>
            <div className={classNames.iconButton} ref={_target}
                onClick={() => { if (!props.isVisibleOnHover) setIsCalloutVisible(!isCalloutVisible) }}
                onMouseEnter={() => { if (props.isVisibleOnHover) setIsCalloutVisible(true) }}
                onMouseLeave={() => { if (props.isVisibleOnHover) setIsCalloutVisible(false) }}
            >
                <IconButton
                    iconProps={{ iconName: "Lightbulb", styles: iconStyles }}
                    styles={bubbleStyles}
                />
                {isCalloutVisible &&
                    <Callout
                        directionalHint={DirectionalHint.bottomAutoEdge}
                        gapSpace={0}
                        layerProps={{ styles: { root: { height: 100 } } }}
                        onDismiss={() => setIsCalloutVisible(false)}
                        setInitialFocus={true}
                        styles={{ root: { maxWidth: 300 } }}
                        target={_target.current}
                    >
                        <div className={classNames.inner}>
                            {/*{props.hint}*/}
                            {/*MG: 07/02/2023 - 2156*/}
                            {props.content} 
                        </div>
                    </Callout>
                }
            </div>
        </Stack.Item>

    </Stack>;

};

HintWrapper.propTypes = {
    color: PropTypes.string, // Couleur de la bulle d'aide
    //hint: PropTypes.string, // Texte affiché dans la bulle d'aide
    isVisibleOnHover: PropTypes.bool, // Détermine si la bulle s'affiche au hover (true) ou au clic (false)
    size: PropTypes.number, // Taille (en px) de la bulle
    verticalAlign: PropTypes.oneOf(Object.values(HintVerticalPosition)), // Position de la bulle
    verticalOffset: PropTypes.number, // Décalage (en px) de la bulle par rapport au bord supérieur ou inférieur
    content: PropTypes.element
};

HintWrapper.defaultProps = {
    color: "red",
    /*hint: "Utilisez la props hint pour personnaliser ce message.",*/
    isVisibleOnHover: false,
    size: 25,
    verticalAlign: HintVerticalPosition.center,
    verticalOffset: 0,
    content: <div>This is the default content</div>,
};
